import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PhonesAdminComponent } from "@onsip/web/features/administrators/phones/phone-admin-page.component";
import { PhoneSetupComponent } from "@onsip/web/features/administrators/phones/phoneSetup/phone-setup.component";
import { AdminGuard } from "../../shared/guards/adminGuard.guard";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        canActivate: [AdminGuard],
        pathMatch: "full",
        component: PhonesAdminComponent
      },
      {
        path: "phone-setup",
        canActivate: [AdminGuard],
        pathMatch: "full",
        component: PhoneSetupComponent,
        data: { title: "Phones setup" }
      }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class PhonesRoutingModule {}
